class Bookmark {
    constructor(title, url, tags = [], date = null, id) {
        this.title = title; // 书签标题
        this.url = url; // 书签 URL
        this.tags = tags; // 书签标签
        this.date = date; // 书签日期
        this.id = id;
    }
}

export default Bookmark; 